import request from '@/router/axios';
const urlPrefix = '/ht/invoice'

//查询发票列表接口
export const getQueryInvoiceList = (obj)=>{
    return request({
        url: urlPrefix + '/queryInvoiceList',
        method: 'POST',
        data: obj
    })
}

//下载文件地址
export const downloadInvoice = (invoiceId)=>{
    return urlPrefix + '/downloadInvoice?invoiceId='+invoiceId
}